import React from 'react'
import MailFooterEditor from './MailFooterEditor'
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import MailFooterOptions from './MailFooterOptions'

const MailFooterView = ({isActive}) => {


  return (
    <div>
      <Typography variant='h6'>E-Mail Footer Abrechnungen</Typography>
      <Paper style={{padding: '0.6rem'}}>
        <div>
          <div className='ql-switch-wrapper'>
            <MailFooterOptions />
          </div>
          <div id='root'>
            <MailFooterEditor  />
          </div>
        </div>
      </Paper>
    </div>
  )
}
export default connect((state) => {
  return ({
      isActive: state.mailFooter.isActive,
  })
})(MailFooterView)
